<div class="container">
	<form [formGroup]="formGroup" class="container__form">
		<form-section [title]="'DRAWERS.CREATION.SECTIONS.PARAMETERS' | translate">
			<form-row>
				<form-field>
					<lawyal-autocomplete
						[formControlName]="CLIENT_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.CLIENT.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.CLIENT.LABEL'"
						[dataSource]="autocompleteDataSource.Client"
						[isPaginated]="true"
					>
					</lawyal-autocomplete>
				</form-field>
				<form-field>
					<free-text-input
						[formControlName]="CONTACT_NAME_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.CONTACT_NAME.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.CONTACT_NAME.LABEL'"
					>
					</free-text-input>
				</form-field>
			</form-row>
			<form-row>
				<form-field>
					<free-text-input
						[formControlName]="COMPANY_NAME_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.COMPANY_NAME.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.COMPANY_NAME.LABEL'"
					>
					</free-text-input>
				</form-field>
				<form-field>
					<free-text-input
						[formControlName]="TAX_ID_NAME_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.TAX_ID.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.TAX_ID.LABEL'"
					>
					</free-text-input>
				</form-field>
			</form-row>
			<form-row>
				<form-field>
					<free-text-input
						[formControlName]="DEPARTMENT_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.DEPARTMENT_NAME.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.DEPARTMENT_NAME.LABEL'"
					>
					</free-text-input>
				</form-field>
				<form-field>
					<free-text-input
						[formControlName]="POSITION_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.POSITION_NAME.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.POSITION_NAME.LABEL'"
					>
					</free-text-input>
				</form-field>
			</form-row>
			<form-row>
				<form-field>
					<free-text-input
						[formControlName]="PHONE_CONTROL_NAME"
						[placeholder]="'DRAWERS.CREATION.CONTROLS.PHONE.LABEL'"
						[label]="'DRAWERS.CREATION.CONTROLS.PHONE.LABEL'"
						[isLtr]="true"
					>
					</free-text-input>
				</form-field>
				<form-field>
					<free-text-input
						[formControlName]="EMAIL_CONTROL_NAME"
						[placeholder]="'DRAWERS.CREATION.CONTROLS.EMAIL.LABEL' | translate"
						[label]="'DRAWERS.CREATION.CONTROLS.EMAIL.LABEL' | translate"
					>
					</free-text-input>
				</form-field>
			</form-row>
			<form-row>
				<form-field>
					<free-text-input
						[formControlName]="FAX_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.FAX.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.FAX.LABEL'"
						[isLtr]="true"
					>
					</free-text-input>
				</form-field>
				<form-field>
					<free-text-input
						[formControlName]="ADDRESS_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.ADDRESS.LABEL' | translate"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.ADDRESS.LABEL' | translate"
					>
					</free-text-input>
				</form-field>
			</form-row>
		</form-section>
	</form>
	<form-actions class="container__buttons-wrapper">
		<submit-button [title]="'DRAWERS.BUTTONS.CLEAR_ALL' | translate" (onClick)="onClearAll()"></submit-button>
		<submit-button [title]="'DRAWERS.BUTTONS.SEARCH' | translate" [filled]="true" (onClick)="onSubmit()"></submit-button>
	</form-actions>
</div>
